<template>
<div class="folders">
    <!-- <h2>Folders (10)</h2> -->
    <div class="close-option"></div>
    <ul class="folder-listing">
      <li class="img-file" >
        <div
          class="img icons" 
          :class="{'select-img':selectedFiles[index]}"
          v-for="(getSearch,index) in getSearch.data"
          :key="index"
        >
        <component
            :url="getSearch.file_url"
            :is="findMimeTypeViewer(index)"
          ></component>
          <!-- <img src="images/ic_music.svg" alt=""> -->
          <!-- <span class="select-icon" @click="selectFiles(index)"></span> -->
          <span>{{getSearch.name}}</span>
        </div>
      </li>
      <!-- <loader91 v-if="isLoading"></loader91> -->
    </ul>
    <!-- add popup -->
  </div>
  
</template>
<script>
import ImageViewer from "../components/FileViewer/ImageViewer";
import DefaultViewer from "../components/FileViewer/DefaultViewer";
import DocsViewer from "../components/FileViewer/DocsViewer";
import VideoViewer from "../components/FileViewer/VideoViewer";
// import axios from "axios";
import {mapGetters} from 'vuex';
export default {
  data(){
    return{
    // user_image: {},
    searchfile:"",
    selectedFiles:[],
    activeUrl:""
  };
  },
  components: {
    ImageViewer,
    DefaultViewer,
    DocsViewer,
    VideoViewer,
  },
  computed:{
          ...mapGetters(['getSearch'])
  },

  mounted() {
  },
  methods: {
    findMimeTypeViewer(index) {
      let activeUrl = index;
      let url = this.getSearch.data[activeUrl].file_url;
      // console.log("url",url)
      let urlArray = url.split(".");
      let mimeType = urlArray[urlArray.length - 1];
      const imagesMimeTypes=['jpg','jpeg','png'];
      const videosMimeTypes = ["mp4", "WebM", "Ogg"];
      const docsMimeTypes = ["pptx", "doc", "docx", "pdf", "xlsx"];
      if (imagesMimeTypes.indexOf(mimeType) > -1) {
        // console.log('image');
        return "ImageViewer";
      } else if (videosMimeTypes.indexOf(mimeType) > -1) {
        return "VideoViewer";
      } else if (docsMimeTypes.indexOf(mimeType) > -1) {
        return "DocsViewer";
      }
       return "DefaultViewer"; // for default mimetypes
      // console.log('mimetype: ',mimeType);
    },
 selectFiles(index) {
      this.$set(this.selectedFiles, index, !this.selectedFiles[index]); 
      //this.showMOdel=true;
      // this.activeUrl=index
    },
  

  }

};
</script>